var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"CoveoLogo d-flex flex-row align-center",attrs:{"to":"/"}},[_c('CoveoWhite',{staticClass:"logo mr-3"}),_c('div',{staticClass:"separator mr-3"}),_c('span',{staticClass:"level-up mr-3"},[_vm._v("Level Up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }